import { render, staticRenderFns } from "./NsBifrostButton.vue?vue&type=template&id=82a18ed0&scoped=true&"
import script from "./NsBifrostButton.vue?vue&type=script&lang=js&"
export * from "./NsBifrostButton.vue?vue&type=script&lang=js&"
import style0 from "./NsBifrostButton.vue?vue&type=style&index=0&id=82a18ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a18ed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82a18ed0')) {
      api.createRecord('82a18ed0', component.options)
    } else {
      api.reload('82a18ed0', component.options)
    }
    module.hot.accept("./NsBifrostButton.vue?vue&type=template&id=82a18ed0&scoped=true&", function () {
      api.rerender('82a18ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsBifrostButton.vue"
export default component.exports